import clsx from "clsx";
import {Menu, MenuButton, MenuItem, MenuItems} from "@headlessui/react";
import {ChevronDown} from "@chayka/icons";

export interface TSelectItem<T = string> {
  label: string;
  value: T;
}

interface DropdownSelectProps<T> {
  selected: TSelectItem<T> | null;
  items: Array<TSelectItem<T>>;
  onSelect: (item: TSelectItem<T>) => void;
  placeholder?: string;
}

export const DropdownSelect = <T,>({
  selected,
  items,
  onSelect,
  placeholder = "",
}: DropdownSelectProps<T>) => {
  return (
    <Menu as="div" className="relative">
      <MenuButton className="relative w-full px-4 py-2 border rounded-md border-gray-300 text-gray-300 focus:outline-none focus:border-blackout flex flex-col items-start justify-center">
        <span className="text-blackout">{selected?.label ?? placeholder}</span>
        <ChevronDown size={20} className="absolute right-2 top-1/2 transform -translate-y-1/2" />
      </MenuButton>
      <MenuItems
        as="div"
        className="absolute top-full left-0 w-full bg-white border-gray-300 rounded-md shadow-lg"
      >
        {items.map((item, index) => (
          <MenuItem key={`${item.value}`}>
            {({focus}) => (
              <button
                type="button"
                onClick={() => onSelect(item)}
                className={clsx(
                  "w-full px-4 py-2 text-left hover:bg-gray-100 cursor-pointer",
                  focus && "bg-gray-100",
                  index > 0 && "border-t border-gray-300",
                )}
              >
                {item.label}
              </button>
            )}
          </MenuItem>
        ))}
      </MenuItems>
    </Menu>
  );
};
